import userInfo from 'utils/userInfo';
import { createLinkTitle } from 'utils/';

const defaultVM = {
  isPreview: false,
  isSaveToDraft: false,
  name: '',
  city: [],
  location: {
    directionLandmarks: '',
    fullAddress: '',
    latitude: 12.9770823,
    longitude: 77.5725585,
    locality: '',
    placeId: '',
  },
  summary: '',
  cuisines: [],
  dishes: [],
  featuredImage: null,
  story: {},
  description: ''
};

const validate = vm => {
  const errors = {};

  // Do not validate if saving as draft
  if (vm.isSaveToDraft) {
    return errors;
  }

  // List of validations when submitting the form
  if (vm.cuisines.length === 0) {
    errors.cuisines = 'Require at least one cuisine.';
  }

  if (!vm.featuredImage) {
    errors.featuredImage = 'Require featured image.';
  }

  if (Object.keys(errors).length) {
    errors.form = 'Please fix the errors in the form.';
  }

  return errors;
};

const mapOptions = ({ id, name: label }) => ({ value: id.toString(), label });

const mapOtherOptions = dish => ({
  value: dish,
  label: dish,
  __isNew__: true,
});

const mapImage = image =>
  image && {
    id: image.id,
    description: image.description || '',
    picCredits: image.picCredits || '',
    uri: image.uri,
  };

const toViewModel = model => {
  const { city = {}, location = {}, cuisines = [], dishes = [] } = model;

  location.fullAddress = location.fullAddress || '';
  location.latitude = location.latitude || 12.9770823;
  location.longitude = location.longitude || 77.5725585;

  return {
    id: model.id,
    name: model.name || '',
    city: [{ value: city.id || '', label: city.name || '' }],
    location,
    summary: model.summary || '',
    cuisines: cuisines.map(mapOptions),
    dishes: dishes.map(mapOptions).concat(dishes.map(mapOtherOptions)),
    featuredImage: mapImage(model.mainImage),
    description: model.content || '',
  };
};

const mapImageToModel = item => {
  let itemName = "Image";
  if (item.name)
    itemName = item.name;
  else if (item.file)
    itemName = item.file.name ? item.file.name : itemName;
  return ({
    description: item.description || '',
    name: createLinkTitle(itemName) || '', // TODO: What should 'name' be?
    picCredits: item.photoCredit || '',
    uri: item.uri,
    file: item.file,
  });
}

const toModel = vm => {
  console.log(vm);
  return ({
    draft: vm.isSaveToDraft,
    id: vm.id,
    title: vm.title,
    city: vm.cities.map((city) => ({ id: city.value })),
    content: vm.content,
    cuisines: vm.cuisines.map((cuisine) => ({ id: cuisine.value })),
    dishes: vm.dishes.map((dish) => ({ id: dish.value, __isNew__: dish.__isNew__ })),
    location: {
      locality: vm.locality
    },
    owner: {
      id: userInfo.getUserID()
    },
    summary: vm.summary,
    mainImage: mapImageToModel(vm.featuredImage),
  })
}

export default {
  defaultVM,
  toModel,
  toViewModel,
  validate,
};
